<template>
  <div class="home">
    <div class="banner">
      <div class="copy">
        <h1 class="x-large-text weight500">Better Grades, Less Effort.</h1>
        <p class="large-text">
          CLEX helps improve grades by organizing notes to prioritize and focus studying.
          This simple, easy-to-use software provides a flexible approach to learning.
        </p>
        <div class="buttons">
          <router-link :to="{name: 'signup'}" class="btn-pub btn-pub-blank signup-btn fixed-width xs-full-width">Sign Up for Free</router-link>
          <a href="https://vimeo.com/204826626" target="_blank" class="btn-pub btn-pub-primary video-btn fixed-width xs-full-width">Watch Our Video</a>
        </div>
      </div>

      <div class="bg">
        <picture title="">
          <!--[if IE 9]><video style="display: none;"><![endif]-->
          <source srcset="/static/img/home/banner6_500.jpg" media="(max-width: 500px)">
          <source srcset="/static/img/home/banner6_800.jpg" media="(min-width: 501px) and (max-width: 767px)">
          <source srcset="/static/img/home/banner6_1200.jpg" media="(min-width: 768px) and (max-width: 1200px)">
          <source srcset="/static/img/home/banner6_1600.jpg" media="(min-width: 1201px) and (max-width: 1600px)">
          <source srcset="/static/img/home/banner6_2000.jpg" media="(min-width: 1601px)">
          <!--[if IE 9]></video><![endif]-->
          <img src="/static/img/home/banner6_1600.jpg" alt="">
        </picture>
        <div class="overlay"></div>
      </div>
    </div>
    <div class="container key-features ptb-100">
      <div class="row text-center">
        <div class="col-sm-4">
          <div class="feature">
            <img src="/static/img/icons/home/Homepage_Icons-01.png" alt="Learn Smarter" />
            <h2 class="xs-mt-50 xs-mb-30">Learn Smarter</h2>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="feature">
            <img src="/static/img/icons/home/Homepage_Icons-02.png" alt="Organize Notes" />
            <h2 class="xs-mt-50 xs-mb-30">Organize Notes</h2>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="feature">
            <img src="/static/img/icons/home/Homepage_Icons-03.png" alt="Remember Everything" />
            <h2 class="xs-mt-50 xs-mb-30">Remember Everything</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap-blue banner-with-copy testimonial">
      <div class="row">
        <div class="col-xs-12 col-push-sm-6 col-sm-6 pic">
          <picture title="">
            <!--[if IE 9]><video style="display: none;"><![endif]-->
            <source srcset="/static/img/home/banner7_400.jpg" media="(min-width: 501px) and (max-width: 800px)">
            <source srcset="/static/img/home/banner7_600.jpg" media="(min-width: 801px) and (max-width: 1200px)">
            <source srcset="/static/img/home/banner7_800.jpg" media="(min-width: 1201px) and (max-width: 1600px)">
            <source srcset="/static/img/home/banner7_1000.jpg" media="(min-width: 1601px)">
            <!--[if IE 9]></video><![endif]-->
            <img src="/static/img/home/banner7_800.jpg" alt="">
          </picture>
        </div>
        <div class="col-xs-12 col-push-sm-6 col-sm-6">
          <div class="banner-copy">
            <p>
              “CLEX helped me reach new heights and accomplish the education of my dreams. After
              studying with micro-notes, I got better grades!”
            </p>
            <p class="name weight500">- Claire, Vancouver</p>
            <router-link :to="{name: 'features'}" class="btn-pub btn-pub-blank fixed-width xs-full-width">Learn More</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="features ptb-80">
      <div class="container">
        <div class="text-center">
          <div class="feature xs-pb-50">
            <img src="/static/img/icons/home/Homepage_Icons-04.png" alt="Focus studying" />
            <h3>Focus studying</h3>
          </div>
          <div class="feature xs-pb-50">
            <img src="/static/img/icons/home/Homepage_Icons-05.png" alt="Access everywhere" />
            <h3>Access everywhere</h3>
          </div>
          <div class="feature xs-pb-50">
            <img src="/static/img/icons/home/Homepage_Icons-06.png" alt="Keywords search" />
            <h3>Keywords search</h3>
          </div>
          <div class="feature xs-pb-50">
            <img src="/static/img/icons/home/Homepage_Icons-07.png" alt="Micro-notes" />
            <h3>Micro-notes</h3>
          </div>
          <div class="feature xs-pb-50">
            <img src="/static/img/icons/home/Homepage_Icons-08.png" alt="One-click import" />
            <h3>One-click import</h3>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="row xs-pt-30">
          <div class="col-xs-12 text-center">
            <router-link :to="{name: 'signup'}" class="btn-pub btn-pub-border-primary fixed-width">Sign Up for Free</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-banner">
      <div class="row">
        <div class="col-xs-12 col-sm-6 pic">
          <picture title="">
            <!--[if IE 9]><video style="display: none;"><![endif]-->
            <source srcset="/static/img/home/banner8_600.jpg" media="(min-width: 501px) and (max-width: 800px)">
            <source srcset="/static/img/home/banner8_600.jpg" media="(min-width: 801px) and (max-width: 1200px)">
            <source srcset="/static/img/home/banner8_800.jpg" media="(min-width: 1201px) and (max-width: 1600px)">
            <source srcset="/static/img/home/banner8_1000.jpg" media="(min-width: 1601px)">
            <!--[if IE 9]></video><![endif]-->
            <img src="/static/img/home/banner8_800.jpg" alt="">
          </picture>
        </div>
        <div class="col-xs-12 col-sm-6 ">
          <div class="banner-text">
            <h2 class="xs-mb-30 weight500">Take the stress out of studying</h2>
            <p class="xs-mb-30">
              We believe learning should be an engaging and rewarding experience. CLEX is
              designed with your brain in mind so you can get back to enjoying the subject you’re passionate about!
            </p>
            <router-link :to="{name: 'features'}" class="btn-pub btn-pub-blank xs-mb-30 fixed-width xs-full-width">Learn More</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import _ from 'underscore'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import QuickLogin from '../login/QuickLogin'

export default {
    components: {
    QuickLogin,
    },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home {background:#FFFFFF;}
  

  .btn-blank, btn-primary {border:1px solid #FFFFFF;border-radius:0px;}

  .banner {position:relative;}
  .banner .copy {color:#FFFFFF;max-width: 480px; margin: 0px auto; text-align: left; position: absolute; top: 15%; left: 10%; z-index: 2;}
  .banner .copy h1 {font-weight:bold;font-size:60px;}
  .banner .copy p { margin: 40px 0px; }
  .banner .copy .buttons {}
  .banner .copy .signup-btn { float:left;margin-bottom:20px;}
  .banner .copy .video-btn { float: left; margin-left:20px;}


  .key-features .feature {padding:0px 20px;}
  .key-features .feature img {width:80%;max-width:150px;}
  .key-features .feature h2 {}
  .key-features .learn-more { font-size: 16px; }

  .testimonial p {font-size:25px;line-height:30px;}

  .features {}
  .features img { width: 50%; }
  .features h3 {margin-top:40px;}
  .features .feature {width:20%;float:left;}
  .features .learn-more {}

  .testimonial .btn-pub { font-size: 20px; }

  .bottom-banner .pic img { width: 100%; }
  .bottom-banner { color: #FFFFFF; background-image: linear-gradient(#20252d, #313a48); }
    .bottom-banner .pic {height:100%;overflow:hidden;}
    .bottom-banner .banner-text { padding: 10% 10% 0% 10%; }
  .bottom-banner .banner-text p { font-size: 20px; font-weight: normal;line-height:24px; }

  @media only screen and (max-width: 1400px) {
    .testimonial p { font-size: 20px; line-height: 25px; }
    .bottom-banner .banner-text { padding: 5% 5% 0% 5%; }

    
  }
  @media only screen and (max-width: 1100px) {
    .banner .copy h1 {line-height:60px;}
    .testimonial p { font-size: 16px; line-height: 20px; margin-top: 0px; }
    .testimonial .btn-pub { font-size: 16px; line-height:36px;margin-bottom:0px;}

    .bottom-banner .pic img {height:100%;width:auto;}
    .bottom-banner .banner-text h2 { }
    .bottom-banner .banner-text p { font-size: 16px; line-height: 20px; }
  }

  @media only screen and (max-width: 767px) {
    .banner {max-height:500px;overflow:hidden;}
    .banner .bg img { width: 260%; margin-left: -70%; }
    .banner .copy { right: 10%;top:5%; }
    .banner .copy h1 { line-height: 40px; font-size: 40px; }
    .banner .copy p {margin:20px 0px;}
    .banner .overlay { position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; background: rgba(0,0,0,0.7); }
    .banner .copy .video-btn {margin:0px;}
    .banner .copy .btn-pub {width:100% !important;}

    .features .feature { width: 100%; float: left; }
    .features .feature img { width: 100px; }

    .bottom-banner .pic img { height: auto; width: 100%; }
  }
</style>



// WEBPACK FOOTER //
// HomePage.vue?7b23c60c